import { createBrowserHistory } from 'history';

// Create browser history to use in the Redux store
const baseUrl = document.querySelectorAll('base')[0].getAttribute('href');
export default createBrowserHistory({ basename: baseUrl });
